export default __webpack_public_path__ + "static/media/eyegorSL.54724f30.jpg";